import React, {Component} from 'react';
import {Button, Col, Form, FormGroup, Input, Label} from 'reactstrap';


class BatchUploader extends Component {
	constructor(props) {
		super(props);

		this.state = {
			inputVal: 1
		};

		this.runBatch = this.runBatch.bind(this);
	}

	runBatch() {
		// let input = document.getElementById(this.props.inputID);
		// let iterations = input.value;
		let iterations = this.state.inputVal;
		console.log(iterations);
		if (iterations <= 0) {
			return;
		}

		this.props.toggle();
		if (this.props.modalToggle) {
			this.props.modalToggle();
		}
		this.props.loader();
		// cause this is way more than a promise.
		let covenants = [];

		for (let i = 0; i < iterations; i++) {
			console.log(i);
			covenants.push(this.props.batchFunc());
		}

		Promise.all(covenants).then(
			() => {
				this.props.resetPage();
			},
			() => {
				let err = 'There was an error during batch create';
				this.props.reportErr(err);
				this.props.loader();
			}
		);
	}

	render() {
		if (!this.props.show) {
			return;
		}

		return (
			<Form
				className="multiAddCont"
				onSubmit={(e) => {
					e.preventDefault();
					this.runBatch();
				}}>
				<FormGroup row className="multiAdd">
					<Label for={this.props.inputName} className="col pt-2 pb-0 mr-1 text-right">How Many?</Label>
					<Input
						className="mr-2 col-sm-2 rounded-0 textinput"
						type="number"
						name={this.props.inputName}
						id={this.props.inputID}
						onChange={(e) => {
							this.setState({inputVal: e.target.value});
						}}
						value={this.state.inputVal}
					/>
					<Button
						className="mr-2 button shortBtn batch-confirm-btn"
						onClick={() => {
							this.runBatch();
						}}>
						Create
					</Button>
					<Button
						className="mr-2 button shortBtn"
						onClick={this.props.toggle}>
						Cancel
					</Button>
				</FormGroup>
			</Form>
		);
	}
}

export default BatchUploader;



// WEBPACK FOOTER //
// ./src/components/BatchUploader.js